/* eslint-disable indent */
// import { yupResolver } from '@hookform/resolvers/yup';
// import { createMidtermReviewValidationSchema } from 'features/MidtermReview/validate';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useMemo, useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ReactRouterPrompt from 'react-router-prompt';
import { CreateForm } from 'features/MidtermReview/components';
import {
  createMidtermReview,
  getDetail,
  getGeneralProjectProposalInfo,
} from 'apis/midtermReviews.api';
import { toast } from 'layout';
import { TOAST } from 'constant';
import { getAllVersions } from 'apis/projectProposals.api';
import DynamicMidtermForm from 'features/MidtermReview/components/DynamicMidtermForm';
import { is1593 } from 'utils/func';
// import { defaultMidtermReview } from '../../_constant';

export default function MidtermReviewFormCreate() {
  const { t } = useTranslation();
  const [isVisibleErrorDialog, setIsVisibleDialogError] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { fromInternal } = location.state || { fromInternal: false };
  const { projectProposalId, projectId, summaryReportId } = useParams();
  const [searchParams] = useSearchParams();
  const councilId = searchParams.get('councilId');
  const councilMemberId = searchParams.get('councilMemberId');
  const userId = searchParams.get('userId');

  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues,
    formState: {
      errors,
      // , isValid
    },
  } = useForm({
    mode: 'onChange',
    // resolver: yupResolver(createMidtermReviewValidationSchema),
  });
  const { isDirty, dirtyFields } = useFormState({ control });

  // general info projectProposal
  const { data: allProjectProposalVersionsData, isLoading: isLoadingAllVersion } = useQuery(
    ['allProjectProposalVersions', projectProposalId],
    () => getAllVersions(projectProposalId)
  );

  // The projectProposal version ONLY used to get information of projectProposal (A. General)
  const prequalificationVersion = useMemo(() => {
    if (allProjectProposalVersionsData?.data?.length > 0) {
      return (
        (allProjectProposalVersionsData?.data?.find((item) => item?.version === 4) ||
          allProjectProposalVersionsData?.data?.find((item) => item?.version === 1)) ??
        null
      );
    }
    return null;
  }, [allProjectProposalVersionsData]);

  const { data: dataGeneralProjectProposalInfo, isLoading: isLoadingProjectProposal } = useQuery(
    ['midterm-review', 'project-proposal', councilId, prequalificationVersion?.id],
    ({ queryKey: [, , _councilId, _projectProposalId] }) =>
      getGeneralProjectProposalInfo(_councilId, _projectProposalId),
    { enabled: !!prequalificationVersion?.id }
  );

  const { data: midtermReviewData, isLoading: isLoadingMidtermReview } = useQuery(
    ['midterm-review'],
    () => getDetail(councilMemberId, councilId, projectProposalId),
    {
      enabled: !fromInternal,
    }
  );

  const {
    mutate,
    error: errorRes,
    isError: isErrorRes,
    isLoading: isLoadingCreate,
  } = useMutation(createMidtermReview);

  const onSubmit = async (data) => {
    const evaluatesReview = {};

    Object.keys(data?.evaluate).forEach((key) => {
      evaluatesReview[key] = data?.evaluate[key].isQualified ?? false;
    });

    const submitData = {
      // ...defaultMidtermReview,
      userId,
      councilMemberId,
      projectProposalId,
      councilId,
      ...evaluatesReview,
      requestStop: data?.requestStop,
      requestStopReason: data?.requestStopReason,
      requestContinue: data?.requestContinue,
      requestContinueModify: data?.requestContinueModify,
      otherReview: data?.otherReview,
      reviewContinueAbility: data?.reviewContinueAbility,
      reviewExpenditureUsed: data?.reviewExpenditureUsed,
      reviewProgress: data?.reviewProgress,
      reviewProduct: data?.reviewProduct,
      reviewResearchPlan: data?.reviewResearchPlan,
    };

    mutate(submitData, {
      onSuccess: () => {
        reset({}, { keepValues: true });
        toast(TOAST.SUCCESS, t('council.review.createSuccess'));
        setTimeout(() => {
          const queryParams = `councilId=${councilId}&councilMemberId=${councilMemberId}&userId=${userId}`;
          navigate(
            `/projects-submit/${projectId}/${projectProposalId}/${summaryReportId}/midterm-document/midterm-review/edit?${queryParams}`,
            { replace: true }
          );
        }, 1500);
      },
      onError: () => {
        setIsVisibleDialogError(true);
      },
    });
  };

  const footerConfirmationPrompt = (onConfirm, onCancel) => (
    <div>
      <Button
        label={t('formLayout.action.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={onCancel}
        autoFocus
      />
      <Button
        label={t('formLayout.action.ok')}
        className="w-7rem"
        severity="info"
        onClick={onConfirm}
      />
    </div>
  );

  const template = useMemo(
    () => parseInt(dataGeneralProjectProposalInfo?.data?.template, 10) || null,
    [dataGeneralProjectProposalInfo]
  );

  const renderForm = () => {
    if (is1593(template) || isLoadingProjectProposal || isLoadingAllVersion) {
      return (
        <DynamicMidtermForm
          projectProposalId={prequalificationVersion?.id}
          councilMemberId={councilMemberId}
          councilId={councilId}
          generalInfo={dataGeneralProjectProposalInfo?.data}
          isLoading={isLoadingProjectProposal || isLoadingAllVersion}
        />
      );
    }
    return (
      <CreateForm
        isLoadingCreate={isLoadingCreate || isLoadingProjectProposal}
        isErrorRes={isErrorRes}
        errorRes={errorRes}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        control={control}
        watch={watch}
        setValue={setValue}
        getValues={getValues}
        isDirty={isDirty}
        dirtyFields={dirtyFields}
        errors={errors}
        isValid
        isVisibleErrorDialog={isVisibleErrorDialog}
        setIsVisibleDialogError={setIsVisibleDialogError}
      />
    );
  };

  if (!isLoadingMidtermReview && midtermReviewData?.data?.midtermReview) {
    const queryParams = `councilId=${councilId}&councilMemberId=${councilMemberId}&userId=${userId}`;
    navigate(
      `/projects-submit/${projectId}/${projectProposalId}/${summaryReportId}/midterm-document/midterm-review/edit?${queryParams}`,
      { replace: true }
    );
  }
  // #endregion

  return (
    <>
      <ReactRouterPrompt when={isDirty && Object.keys(dirtyFields).length}>
        {({ isActive, onConfirm, onCancel }) => (
          <Dialog
            visible={isActive}
            header={<p className="text-blue-500">{t('projectProposal.confirmationTitle')}</p>}
            position="center"
            style={{ width: '300px' }}
            onHide={onCancel}
            draggable={false}
            footer={() => footerConfirmationPrompt(onConfirm, onCancel)}
          >
            <p className="text-lg py-3">{t('projectProposal.confirmationPromptMessage')}</p>
          </Dialog>
        )}
      </ReactRouterPrompt>
      {renderForm()}
    </>
  );
}
